var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8648 10.3205V11.146C30.9011 21.9843 22.1443 30.7998 11.306 30.8361C11.2622 30.8363 11.2184 30.8363 11.1747 30.8361C7.43521 30.7881 3.78085 29.7133 0.61084 27.7291H2.27099C5.35509 27.784 8.36098 26.7568 10.7666 24.8261C7.80886 24.8236 5.20006 22.8887 4.33925 20.0589C4.75661 20.0589 5.16477 20.263 5.58207 20.263C6.20733 20.2953 6.8337 20.2264 7.43699 20.0589C4.21867 19.3448 1.91442 16.5106 1.87219 13.2142C2.80955 13.7773 3.88589 14.0664 4.97921 14.049C3.18858 12.6479 2.12268 10.5161 2.07624 8.24302C2.10261 6.99671 2.46121 5.78002 3.11501 4.71864C6.60792 9.09202 11.8244 11.7375 17.4165 11.9714C17.227 11.443 17.1542 10.8798 17.2032 10.3205C17.2379 6.57635 20.2485 3.54103 23.9923 3.47584C25.9227 3.4308 27.7677 4.27129 29.0006 5.75741C30.5617 5.55679 32.0527 4.98774 33.3504 4.09724C32.7965 5.66838 31.693 6.98609 30.2434 7.80712C31.6576 7.61037 33.0472 7.2653 34.3892 6.77763C33.4345 8.15881 32.241 9.35858 30.8648 10.3205V10.3205Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.daf693e686d8a0273ba76b7d2ec191b4.svg";
export { ForwardRef as ReactComponent };